import { useState } from "react";
import { setStoredAccessToken } from "../api/client";
import { saveTeacherOnboarding } from "../api/teacher";
import { useAuth } from "../context/AuthContext";
import { CreateAccountPage } from "./CreateAccountPage";
import { LoginPage } from "./LoginPage";
import { OnboardingPage } from "./OnboardingPage";

export function AuthEntryPage() {
  const { establishSession } = useAuth();
  const [view, setView] = useState("login");
  const [pendingAccount, setPendingAccount] = useState(null);
  const [pendingSession, setPendingSession] = useState(null);

  if (view === "onboarding") {
    return (
      <OnboardingPage
        account={pendingAccount}
        onComplete={async (onboarding) => {
          if (pendingSession?.accessToken) {
            setStoredAccessToken(pendingSession.accessToken);
            try {
              await saveTeacherOnboarding(onboarding);
            } catch {
              // Best-effort onboarding persistence; session still proceeds.
            }
          }
          if (pendingSession) {
            establishSession(pendingSession);
          }
          setPendingAccount(null);
          setPendingSession(null);
        }}
      />
    );
  }

  if (view === "create-account") {
    return (
      <CreateAccountPage
        onLogin={() => setView("login")}
        onAccountCreated={(account) => {
          setPendingAccount({
            firstName: account.firstName,
            lastName: account.lastName,
            email: account.email,
          });
          setPendingSession(account.session ?? null);
          setView("onboarding");
        }}
      />
    );
  }

  return (
    <LoginPage
      onCreateAccount={() => {
        setView("create-account");
      }}
    />
  );
}
